import { render, staticRenderFns } from "./AccordionTable.vue?vue&type=template&id=0a1df8d6"
import script from "./AccordionTable.vue?vue&type=script&lang=js"
export * from "./AccordionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports